"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoverChange = void 0;
class CoverChange {
}
exports.CoverChange = CoverChange;
//# sourceMappingURL=CoverChange.js.map